import { HttpContext, HttpContextToken } from '@angular/common/http';

export function isInterceptorDisabled(httpContext: HttpContext, httpContextToken: HttpContextToken<boolean>): boolean {
  return httpContext.get(httpContextToken);
}
